export enum MaterialShape {
	Sheet = 0,
	Billet = 10,
	Tube = 20,
	Coil = 30,
	BoxSection = 40,
	Angle = 50,
}